module.exports = __webpack_public_path__ + "img/login_bsgs.6f37d3b0.svg";